export default "__VITE_ASSET__CPjTM0Ww__"